import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../../shared/shared.module';
import { TourCardComponent } from './components/tour-card/tour-card.component';
import { TourOutletComponent } from './components/tour-outlet/tour-outlet.component';
import { TourWindowComponent } from './components/tour-window/tour-window.component';

@NgModule({
  imports: [CommonModule, SharedModule, FlexLayoutModule],
  declarations: [TourOutletComponent, TourWindowComponent, TourCardComponent],
  exports: [TourOutletComponent],
})
export class TourModule {}
